// @flow

import React from 'react';
import { Button, Grid, Form as UIForm } from 'semantic-ui-react';
import { Form } from 'react-form';
import { connect } from 'react-redux';

import Input from 'forms/Input';
import { login } from 'actions/auth';
import type { LoginFn } from 'actions/auth';
import { setToken } from 'helpers/auth';

type Props = {
  login: LoginFn
};

const Login = (props: Props) => (
  <Grid centered>
    <Grid.Row>
      <Grid.Column mobile={16} tablet={8} computer={4}>
        <Form
          className="ui form"
          onSubmit={async values => {
            // eslint-disable-next-line
            const { login, history, match } = props;
            const { response } = await login(values);

            if (response) {
              // later we won't need this
              localStorage.setItem('id', response.id);

              setToken(response.token);

              if (match.params.token) {
                history.push(`/confirm-invitation/${match.params.token}`);
              } else {
                history.push('/');
              }
            }
          }}
        >
          {formApi => (
            <form onSubmit={formApi.submitForm}>
              <UIForm as="div">
                <UIForm.Field>
                  <label htmlFor="email">Email</label>
                  <Input id="email" placeholder="Email" field="username" />
                </UIForm.Field>
                <UIForm.Field>
                  <label htmlFor="password">Password</label>
                  <Input
                    placeholder="Password"
                    id="password"
                    field="password"
                    type="password"
                  />
                </UIForm.Field>
                <Button type="submit">Login</Button>
              </UIForm>
            </form>
          )}
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default connect(
  null,
  { login }
)(Login);



// WEBPACK FOOTER //
// ./src/screens/Login/index.js